import { TextField, MenuItem } from '@mui/material';
import { Controller } from 'react-hook-form';

const HookFormTextField = ({
  name,
  label,
  helperText,
  formMethods,
  onChange: onChangeHandler = () => {},
  deps = [],
  options,
  children,
  select = false,
  ...props
}) => {
  const {
    control,
    trigger,
    formState: { errors },
  } = formMethods;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextField
          id={name}
          name={name}
          label={label || name}
          helperText={errors[name]?.message || helperText || ''}
          error={errors[name] && Boolean(errors[name])}
          value={value || (value === 0 ? 0 : '')}
          onChange={event => {
            deps.forEach(dep => trigger(dep));
            onChange(event);
            onChangeHandler(event);
          }}
          select={select}
          {...props}>
          {select && options
            ? options.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            : children}
        </TextField>
      )}
    />
  );
};

export default HookFormTextField;
